/**
 * El nombre de la persona logueada, como lo ve el equipo: «Ruben Quispe».
 *
 * Hasta el 13-oct-2026 el pie del menú mostraba «rquispe», lo de antes de la
 * @ del email. El nombre ya estaba: Google lo trae al federar la cuenta y el
 * mapeo del IdP lo deja en `given_name` / `family_name` de Cognito en cada
 * login —medido ese día: los 7 usuarios de TEST y los 2 de PROD los tienen—, y
 * el ID token los lleva. Se toma el PRIMER nombre y el primer apellido, como
 * `nombre_de_persona` del servidor (`portal_api/auth/principal.py`), que es
 * con el que el Copiloto firma: el asesor tiene que verse llamado igual en los
 * dos lugares.
 *
 * Puro: lo corre `tests/unit/test_nombre_de_la_cuenta.py` en Node.
 */

function palabras(valor: unknown): string[] {
  return typeof valor === 'string' ? valor.trim().split(/\s+/).filter(Boolean) : []
}

/** «Ruben Quispe» de los claims del ID token, o '' si no vienen. */
export function nombreDelToken(claims: Record<string, unknown>): string {
  const pila = palabras(claims['given_name'])
  const apellido = palabras(claims['family_name'])
  return pila.length ? [pila[0], ...apellido.slice(0, 1)].join(' ') : ''
}

/** Lo que se muestra: el nombre, o el usuario del email si todavía no hay nombre. */
export function nombreVisible(nombre: string, email: string): string {
  return nombre || (email.split('@')[0] ?? '')
}

/** «RQ» del nombre; sin nombre, las dos primeras letras del email. */
export function iniciales(nombre: string, email: string): string {
  const partes = nombre.trim().split(/\s+/).filter(Boolean)
  if (partes.length >= 2) return (partes[0][0] + partes[1][0]).toUpperCase()
  if (partes.length === 1) return partes[0].slice(0, 2).toUpperCase()
  return email ? email.split('@')[0].slice(0, 2).toUpperCase() : '??'
}
